import { COLLECTIONS_IS_OPEN_COLLECTION_CREATE_WITH_REST_API } from './constants';

export function isOpenCollectionCreateWithRestApi() {
  return {
    type: COLLECTIONS_IS_OPEN_COLLECTION_CREATE_WITH_REST_API,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_IS_OPEN_COLLECTION_CREATE_WITH_REST_API:
      return {
        ...state,
        isOpenCollectionCreateWithRestApi: !state.isOpenCollectionCreateWithRestApi,
      };

    default:
      return state;
  }
}
